/*
    Generic.js -
 */

import {State} from '@/paks/vu-app'
import {Rest} from '@/paks/vu-app'

class Generic {
    constructor() {
        this.rest = new Rest(
            'Generic',
            {
                fetch: {method: 'POST', uri: '/:controller/fetch'},
            },
            {cache: false}
        )
    }
    async create(model, fields = {}, options = {}) {
        this.setFields(fields, model)
        return this.rest.create(fields, options)
    }
    async get(model, fields = {}, options = {}) {
        this.setFields(fields, model)
        return this.rest.get(fields, options)
    }
    async find(model, fields = {}, options = {}) {
        this.setFields(fields, model)
        return this.rest.find(fields, options)
    }
    async remove(model, fields = {}, options = {}) {
        this.setFields(fields, model)
        return this.rest.remove(fields, options)
    }
    async update(model, fields = {}, options = {}) {
        this.setFields(fields, model)
        return this.rest.update(fields, options)
    }

    setFields(fields, model) {
        if (model) {
            fields._type = model
        }
        if (State.context.deviceId) {
            fields.deviceId = State.context.deviceId
        }
    }
}

export default new Generic()
